
 

const baseURL = 'https://arjtuweb.com/';

export default baseURL;